import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AssetRegisterReportWidget from '../../../widgets/durableArticlesWidget/assetRegisterReportWidgets/AssetRegisterReportWidget'
import { getAssetReportPage } from '../../../redux/actions/addDurableArticles'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function AssetRegisterReport() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetReportPage(projectCode)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <AssetRegisterReportWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )

  const x = {
    header: 'รายงาน',
    subHeader: 'รายงานโครงการย่อย',
    form: {
      header: 'ค้นหาข้อมูล',
      reportName: 'รายงานโครงการย่อย',
      columnDisplay: 'two',
      buttonText: {
        disabled: true,
        errorMessage: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
        downloadButtonName: 'ดาวน์โหลด Excel',
        previewButtonName: null,
        cancelButtonName: 'ยกเลิก',
      },
      searchObject: {
        constYear: {
          options: [
            {
              disabled: false,
              label: '2566',
              value: 2566,
            },
            {
              disabled: false,
              label: '2565',
              value: 2565,
            },
            {
              disabled: false,
              label: '2564',
              value: 2564,
            },
          ],
          name: 'constYear',
          label: 'ปีงบประมาณ : ',
          value: '',
          disabled: false,
        },
        projectDepartment: {
          options: [
            {
              disabled: false,
              label: 'ฝ่ายอำนวยการ',
              value: 1,
            },
            {
              disabled: false,
              label: 'สำนัก 1',
              value: 2,
            },
            {
              disabled: false,
              label: 'สำนัก 2',
              value: 3,
            },
            {
              disabled: false,
              label: 'สำนัก 3',
              value: 4,
            },
            {
              disabled: false,
              label: 'สำนัก 4',
              value: 5,
            },
            {
              disabled: false,
              label: 'สำนัก 5',
              value: 6,
            },
            {
              disabled: false,
              label: 'สำนัก 6',
              value: 7,
            },
            {
              disabled: false,
              label: 'สำนัก 7',
              value: 8,
            },
            {
              disabled: false,
              label: 'สนย.',
              value: 9,
            },
            {
              disabled: false,
              label: 'สภส.',
              value: 10,
            },
            {
              disabled: false,
              label: 'ศรร.',
              value: 11,
            },
            {
              disabled: false,
              label: 'ฝ่ายบริหารบุคคล',
              value: 12,
            },
            {
              disabled: false,
              label: 'ฝ่ายเทคโนโลยีฯ',
              value: 13,
            },
            {
              disabled: false,
              label: 'สำนักวิชาการและนวัตกรรม',
              value: 14,
            },
            {
              disabled: false,
              label: 'ฝ่ายติดตามประเมินผล',
              value: 15,
            },
            {
              disabled: false,
              label: 'ฝ่ายสื่อสารองค์กร',
              value: 16,
            },
            {
              disabled: false,
              label: 'ฝ่ายบัญชีฯ',
              value: 17,
            },
            {
              disabled: false,
              label: 'สำนัก 8',
              value: 18,
            },
            {
              disabled: false,
              label: 'สำนัก 9',
              value: 19,
            },
            {
              disabled: false,
              label: 'ฝ่ายตรวจสอบภายใน',
              value: 20,
            },
            {
              disabled: false,
              label: 'กลุ่มงานวิชาการฯ',
              value: 21,
            },
            {
              disabled: false,
              label: 'สำนักสื่อสารการตลาดเพื่อสังคม',
              value: 22,
            },
            {
              disabled: false,
              label: 'สำนักผู้จัดการ',
              value: 23,
            },
            {
              disabled: false,
              label: 'ศูนย์สัญญา',
              value: 24,
            },
            {
              disabled: false,
              label: 'สำนัก 10',
              value: 25,
            },
            {
              disabled: false,
              label: 'สสค.',
              value: 26,
            },
            {
              disabled: false,
              label: 'สำนัก 11',
              value: 27,
            },
            {
              disabled: false,
              label: 'ThaiHealth Academy',
              value: 28,
            },
            {
              disabled: false,
              label: 'SOOK Enterprise',
              value: 29,
            },
          ],
          name: 'projectDepartment',
          label: 'สำนัก : ',
          value: '',
          disabled: true,
        },
        projectCode: {
          name: 'projectCode',
          label: 'รหัสโครงการหลัก : ',
          value: null,
          disabled: false,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอก รหัสโครงการหลัก',
            },
          ],
        },
        projectStatus: {
          options: [
            {
              disabled: false,
              label: 'ลงทะเบียน',
              value: '1',
            },
            {
              disabled: false,
              label: 'กลั่นกรอง',
              value: '2',
            },
            {
              disabled: false,
              label: 'อนุมัติ',
              value: '3',
            },
            {
              disabled: false,
              label: 'ดำเนินการ',
              value: '4',
            },
            {
              disabled: false,
              label: 'ยกเลิกโครงการ',
              value: '7',
            },
            {
              disabled: false,
              label: 'สละสิทธิ์โครงการ',
              value: '8',
            },
            {
              disabled: false,
              label: 'ปิดโครงการ',
              value: '9',
            },
            {
              disabled: false,
              label: 'ยุติโครงการ',
              value: '10',
            },
          ],
          name: 'projectStatus',
          label: 'สถานะโครงการ : ',
          value: '',
          disabled: true,
        },
        projectReportType: {
          options: [
            {
              disabled: false,
              label: 'แบบที่ 1',
              value: '1',
            },
          ],
          name: 'projectReportType',
          label: 'ประเภทรายงาน : ',
          value: '',
          disabled: true,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก ประเภทรายงาน',
            },
          ],
        },
        columns: {
          options: [
            {
              disabled: false,
              label: 'ปีงบประมาณ',
              value: 'BudgetYear',
            },
            {
              disabled: false,
              label: 'สำนัก',
              value: 'DepartmentName',
            },
            {
              disabled: false,
              label: 'รหัสโครงการหลัก',
              value: 'ProjectCode',
            },
            {
              disabled: false,
              label: 'ชื่อโครงการหลัก',
              value: 'ProjectName',
            },
            {
              disabled: false,
              label: 'รหัสโครงการย่อย',
              value: 'SubProjectCode',
            },
            {
              disabled: false,
              label: 'ชื่อโครงการย่อย',
              value: 'SubProjectName',
            },
            {
              disabled: false,
              label: 'ผู้ประสานงาน',
              value: 'Coordinator',
            },
            {
              disabled: false,
              label: 'สถานะ',
              value: 'ProjectStatusName',
            },
            {
              disabled: false,
              label: 'ประเภทรับทุน',
              value: 'GranteeType',
            },
            {
              disabled: false,
              label: 'องค์กรรับทุน',
              value: 'GranteeOrgName',
            },
            {
              disabled: false,
              label: 'ผู้รับทุน',
              value: 'GranteePersonName',
            },
            {
              disabled: false,
              label: 'ผู้รับผิดชอบ',
              value: 'Responsinator',
            },
            {
              disabled: false,
              label: 'งบประมาณ',
              value: 'TotalBudget',
            },
            {
              disabled: false,
              label: 'วันที่เริ่มต้น',
              value: 'ProjectStartDate',
            },
            {
              disabled: false,
              label: 'วันที่สิ้นสุด',
              value: 'ProjectEndDate',
            },
            {
              disabled: false,
              label: 'จังหวัด',
              value: 'Province',
            },
            {
              disabled: false,
              label: 'ประเด็น',
              value: 'Issue',
            },
          ],
          name: 'columns',
          label: 'เลือกคอลัมน์ : ',
          value: '',
          disabled: true,
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก เลือกคอลัมน์',
            },
          ],
        },
      },
    },
  }
}
